import './PeriscopePagination.scss';

import { Pagination } from 'antd';
import { UpdateQueryParams } from '@hooks';

import React, { useCallback } from 'react';

function getScrollableElement(element: HTMLElement | null): HTMLElement | null {
	if (!element) {
		return null;
	}

	if (element && element.scrollTop) {
		return element;
	}

	for (let i = 0; i < element.children.length; i++) {
		const child = element.children[ i ];

		const result = getScrollableElement(child as HTMLElement);

		if (result) {
			return result;
		}
	}

	return null;
}

export type PaginationQueryParams = {
	count: number;
	offset: number;
};

export const paginationDefaultQueryParams: PaginationQueryParams = {
	count: 20,
	offset: 0
};

export const paginationFallbackQueryParams: Partial<PaginationQueryParams> = {
	offset: 0
};

export interface PeriscopePaginationProps {
	loading: boolean;
	onChange: UpdateQueryParams<PaginationQueryParams>;
	queryParams: PaginationQueryParams;
	scrollRef: React.RefObject<HTMLDivElement>;
	totalCount: number;
}

export const PeriscopePagination: React.FC<PeriscopePaginationProps> = ({
	loading,
	onChange,
	queryParams,
	scrollRef,
	totalCount
}) => {
	const handlePaginationChange = useCallback(
		(page: number, pageSize: number) => {
			onChange({
				count: pageSize,
				offset: (page - 1) * pageSize
			});

			setTimeout(() => {
				if (scrollRef.current) {
					const target = getScrollableElement(scrollRef.current);

					if (target) {
						target.scrollTop = 0;
					}
				}
			}, 250);
		},
		[ onChange, scrollRef ]
	);

	if (loading) {
		return null;
	}

	const offset = queryParams.offset ?? paginationDefaultQueryParams.offset;
	const pageSize = queryParams.count ?? paginationDefaultQueryParams.count;
	const page = offset < pageSize ? 1 : Math.ceil((offset + 1) / pageSize);
	const hideOnSinglePage = totalCount <= pageSize;

	return (
		<div className='periscope-field-list-paginator'>
			<Pagination
				current={ page }
				hideOnSinglePage={ hideOnSinglePage }
				onChange={ handlePaginationChange }
				pageSize={ pageSize }
				showSizeChanger
				total={ totalCount } />
		</div>
	);
};
